"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readbackClazz = void 0;
const Cores = __importStar(require("../core"));
const ctx_1 = require("../ctx");
const Neutrals = __importStar(require("../neutral"));
const readback_1 = require("../readback");
const solution_1 = require("../solution");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
function readbackClazz(mod, ctx, clazz) {
    switch (clazz["@kind"]) {
        case "ClazzNull": {
            return Cores.ClazzNull(clazz.name);
        }
        case "ClazzCons": {
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, clazz.propertyName);
            const v = Values.TypedNeutral(clazz.propertyType, Neutrals.Var(freshName));
            const rest = Values.clazzClosureApply(clazz.restClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, clazz.propertyType, ctx);
            const restCore = readbackClazz(mod, ctx, rest);
            return Cores.ClazzCons(clazz.propertyName, freshName, (0, readback_1.readbackType)(mod, ctx, clazz.propertyType), restCore, clazz.name);
        }
        case "ClazzFulfilled": {
            return Cores.ClazzFulfilled(clazz.propertyName, (0, readback_1.readbackType)(mod, ctx, clazz.propertyType), (0, readback_1.readback)(mod, ctx, clazz.propertyType, clazz.property), readbackClazz(mod, ctx, clazz.rest), clazz.name);
        }
    }
}
exports.readbackClazz = readbackClazz;
//# sourceMappingURL=readbackClazz.js.map